module.exports = __webpack_public_path__ + "static/media/transfer_example.e4d15083.png";